// TotpVerification.jsx
import React, { useState } from "react";
import { Form, Button, Alert, Card } from "react-bootstrap";
import "../LoginPageDesktop.scss";

const TotpVerification = ({
  userId,
  onSuccess,
  onCancel,
  loading,
  setLoading,
  error,
  setError,
  t,
}) => {
  const [totpCode, setTotpCode] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    onSuccess(totpCode);
    setLoading(false);
  };

  return (
    <Card className="mt-3 twofa-card">
      <Card.Body>
        <h4 className="text-center mb-4">{t("twoFactorAuth")}</h4>
        {error && <Alert variant="danger">{error}</Alert>}
        <p>{t("enterAuthCode")}</p>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3 w-100">
            <Form.Control
              type="text"
              inputMode="numeric"
              autoFocus
              value={totpCode}
              onChange={(e) =>
                setTotpCode(e.target.value.replace(/\D/g, "").substring(0, 6))
              }
              placeholder={t("sixDigitCode")}
              maxLength="6"
              pattern="\d{6}"
              required
            />
          </Form.Group>

          <div className="d-grid gap-2 twofa-buttons-container">
            <Button
              variant="primary"
              type="submit"
              disabled={loading || totpCode.length !== 6}
            >
              {loading ? `${t("verify") + "..."}` : t("verify")}
            </Button>

            {onCancel && (
              <Button
                variant="outline-secondary"
                onClick={onCancel}
                disabled={loading}
              >
                {t("back")}
              </Button>
            )}
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default TotpVerification;
